var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                attrs: {
                  "config-module": "1100",
                  "show-more-scheme": true,
                  "show-simple": false,
                  "expand-adv": true,
                  "search-item-code": _vm.$t("Insurance.PolicyManagement"),
                  "custom-sim-query-placeholder": _vm.$t(
                    "Insurance.QuickSearchPolicyNumber"
                  )
                },
                on: { advSearchItemCallBack: _vm.fetchData },
                scopedSlots: _vm._u([
                  {
                    key: "searchAreaHeader",
                    fn: function() {
                      return undefined
                    },
                    proxy: true
                  }
                ])
              },
              [
                _c(
                  "template",
                  { slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.viewPolicy }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                    )
                  ],
                  1
                )
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "1100000",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end"
                    }
                  },
                  [
                    _vm.searchConditions.total > 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "orange",
                              "font-size": "20px"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("Insurance.TotalPremium")))]
                        )
                      : _vm._e(),
                    _vm.searchConditions.total > 0
                      ? _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-size": "20px" }
                          },
                          [_vm._v(_vm._s(_vm.totalPremium))]
                        )
                      : _vm._e()
                  ]
                ),
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "190904",
                    total: _vm.searchConditions.total,
                    page: _vm.searchConditions.pageNum,
                    limit: _vm.searchConditions.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.searchConditions, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.searchConditions, "pageSize", $event)
                    },
                    pagination: _vm.fetchDataByPage
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticStyle: { height: "400px" },
          attrs: {
            title: _vm.$t("Insurance.Cancellation"),
            width: "500px",
            visible: _vm.cancellationOfPolicyDialog.visible,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.cancellationOfPolicyDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { "label-width": "50px", "label-position": "left" } },
                [
                  _c("el-form-item", [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Insurance.PleaseInTheCancellationReason")
                        )
                      )
                    ])
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "50px" },
                      attrs: { "label-width": "" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { type: "textarea", rows: 6 },
                        model: {
                          value: _vm.cancellationOfPolicyDialog.reasons,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.cancellationOfPolicyDialog,
                              "reasons",
                              $$v
                            )
                          },
                          expression: "cancellationOfPolicyDialog.reasons"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmCancellationOfPolicy }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.cancellationOfPolicyDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }